import { renderMarkdown } from '@/lib/utils';

/**
 * Renders text with markdown bold/italic support.
 * Usage: <Md className="text-sm text-brand-muted">{someText}</Md>
 * Converts **bold** to <strong> and *italic* to <em>.
 */
export function Md({ children, as: Tag = 'span', className, ...props }) {
  if (!children) return null;
  if (typeof children !== 'string') return <Tag className={className} {...props}>{children}</Tag>;
  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: renderMarkdown(children) }}
      {...props}
    />
  );
}
